module.exports = __webpack_public_path__ + "media/application/images/home/intro_images/feature_depth_mob-cbf357a731da781221324b62861074dd.jpg";